import * as Bixby from '$/core';
import { CacheService } from './CacheService';

export abstract class DisclaimerService {
  public static getDisclaimer(): Date | null {
    const date: Date | null = CacheService.get<Date>(Bixby.Constants.CACHE_DISCLAIMER_ACKNOWLEDGED_DATE);
    return date;
  }

  public static setDisclaimer() {
    CacheService.set(Bixby.Constants.CACHE_DISCLAIMER_ACKNOWLEDGED_DATE, new Date());
  }
}
